export const PROPERTY_WIZARD_STEPS = [
  'تأیید مالکیت',
  'موقعیت ملک',
  'جزئیات ملک',
  'تحلیل مکانی',
  'عکس‌ها',
  'پلان واحد',
  'انتشار آگهی',
  'تأیید اطلاعات',
  'پیشنهاد قیمت هوشمند',
  'برنامه‌ریزی بازدید',
  'خلاصه اطلاعات',
  'نهایی‌سازی',
];

export const SKIPPABLE_PROPERTY_WIZARD_STEPS = new Set([3, 4, 5, 8, 9]);

export const PROPERTY_LIFECYCLE_LABELS = {
  DRAFT: 'پیش‌نویس',
  SUBMITTED: 'ارسال شده',
  ACTIVE: 'فعال',
  INACTIVE: 'غیرفعال',
  SOLD: 'فروخته شده',
  RENTED: 'اجاره داده شده',
};

export const createEmptyStepData = () => ({
  0: {}, 1: {}, 2: {}, 3: {}, 4: {}, 5: {},
  6: {}, 7: {}, 8: {}, 9: {}, 10: {}, 11: {},
});
